










import { Component, Prop, Vue } from 'vue-property-decorator';
import { PlayerConfig } from '@/interfaces/player-config.interface';

import LogoOverlay from '@/components/LogoOverlay.vue';

@Component({
  components: {
    LogoOverlay,
  },
})
export default class StartTemplate extends Vue {
  @Prop() private playerConfig!: PlayerConfig;
}
